import React from 'react'

const Baseball = ({ width = '24px', height = '25px', fill = '#fff' }) => {
  return (
    <svg style={{ width, height, fill }} viewBox='0 0 24 25' version='1.1'>
      <title>baseball</title>
      <g id='Pre-Reg-Landing-Page' stroke='none' strokeWidth='1' fillRule='evenodd'>
        <g id='Desktop-10' transform='translate(-734.000000, -323.000000)' fillRule='nonzero'>
          <g id='Sports-Selection' transform='translate(465.000000, 299.000000)'>
            <g id='onboarding/sport-copy-13' transform='translate(228.000000, 0.000000)'>
              <g id='icon/16/sport/baseball/baseball-bat' transform='translate(41.000000, 24.089286)'>
                <path
                  d='M7.5750356,8.58 C7.5750356,10.3445498 6.14454978,11.775 4.38,11.775 C2.61545022,11.775 1.185,10.3445498 1.185,8.58 C1.185,6.81545022 2.61545022,5.3849644 4.38,5.3849644 C5.22859035,5.38098769 6.04358441,5.71631419 6.64363511,6.31636489 C7.24368581,6.91641559 7.57901231,7.73140965 7.5750356,8.58 Z M23.31,0.69 C22.3767756,-0.224742903 20.8832244,-0.224742903 19.95,0.69 L10.185,10.5 C10.1030947,10.6051296 10.0279437,10.7153511 9.96,10.83 L6.555,15.765 L1.815,20.505 L1.395,20.085 L5.86197757e-14,21.495 L2.505,24 L3.915,22.605 L3.495,22.185 L8.235,17.445 L8.235,17.445 L13.2,14.04 C13.305,13.95 13.44,13.905 13.53,13.815 L23.31,4.05 C24.2247429,3.11677558 24.2247429,1.62322442 23.31,0.69 Z'
                  id='path'
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Baseball
